import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "https://moga-dev.com/api";

// Fetch addons by category ID
export const fetchAddonsByCategory = createAsyncThunk(
  "addons/fetchByCategory",
  async (categoryId, { getState, rejectWithValue }) => {
    try {
      const cityId = getState().citySelection.selectedCity?.id;
      // console.log("selected city id" , cityId);
      const response = await axios.get(
        `${BASE_URL}/addons/category/${categoryId}`,
        {
          headers: {
            cityId: cityId,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch addons");
    }
  }
);

const addonsSlice = createSlice({
  name: "addons",
  initialState: {
    addonsByCategory: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddonsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddonsByCategory.fulfilled, (state, action) => {
        const categoryId = action.meta.arg;
        state.loading = false;
        state.addonsByCategory[categoryId] = action.payload;
      })
      .addCase(fetchAddonsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default addonsSlice.reducer;